import { z } from 'zod';

export const ProviderUserRoleColorSchemes = {
  NATIONAL_MANAGER: 'blue',
  REGIONAL_MANAGER: 'orange',
  STATE_MANAGER: 'yellow',
  SITE_MANAGER: 'green',
  CONSULTANT: 'purple',
} as const;

// Each provider's placeholder site, found by this name only. See Duke HQ in docs/glossary.md.
// A rename also needs the existing site rows and the UI copy that says Duke HQ updated.
export const DUKE_HQ_SITE_NAME = 'Duke HQ';

export const ProviderIdInputSchema = z.union([z.string(), z.number()]).transform(Number);
export type ProviderIdInputType = z.input<typeof ProviderIdInputSchema>;
export type ProviderIdInputSchemaType = z.infer<typeof ProviderIdInputSchema>;
